import { Injectable } from '@angular/core';
import { globals } from '../globals';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class MinhasOcorrenciasService {

  constructor(
    private http: HttpClient
  ) { }

  consultarComPaginacao(
    paginaAtual,
    qtdRegistros,
    campoOrdenacao,
    orientacaoOrdenacao,
    idIntegrador: number,
    idCupom?: string,
    tipoFiltro?: number,
    status?: number[],
    idFuncionario?: number,
    idCliente?: number,
    idTipo?: number,
    inicio?: Date,
    fim?: Date,
    idOcorrencia?: string,
    idFornecedor?: number,
    idSetor?: number,
    numeroNotaFiscal?: string,
    idVendedor?: number,
    etapaOcorrencia?: number
  ) {
    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao)
      .set('tipoFiltro', tipoFiltro ? tipoFiltro.toString() : '0')
      .set('idIntegrador', idIntegrador.toString());

    if (idCupom) {
      parametros = parametros.set('idCupom', idCupom.toString());
    }

    if (idFuncionario) {
      parametros = parametros.set('idFuncionario', idFuncionario.toString());
    }

    if (idFornecedor) {
      parametros = parametros.set('idFornecedor', idFornecedor.toString());
    }

    if (idCliente) {
      parametros = parametros.set('idCliente', idCliente.toString());
    }

    if (idTipo) {
      parametros = parametros.set('idTipo', idTipo.toString());
    }

    if (!!status && status.length) {
      parametros = parametros.set('status', status.toString());
    }

    if (inicio) {
      parametros = parametros.set('inicio', typeof inicio !== 'string' ? inicio.toISOString() : inicio);
    }

    if (fim) {
      parametros = parametros.set('fim', typeof fim !== 'string' ? fim.toISOString() : fim);
    }

    if (idOcorrencia) {
      parametros = parametros.set('idOcorrencia', idOcorrencia);
    }

    if (idSetor) {
      parametros = parametros.set('idSetor', idSetor.toString());
    }

    if (numeroNotaFiscal) {
      parametros = parametros.set('numeroNotaFiscal', numeroNotaFiscal);
    }

    if (idVendedor) {
      parametros = parametros.set('idVendedor', idVendedor.toString());
    }

    if (etapaOcorrencia !== null && etapaOcorrencia !== undefined) {
      parametros = parametros.set('etapaOcorrencia', etapaOcorrencia.toString());
    }

    return this.http.get<any>(globals.apiUrl + '/api/MinhasOcorrencias/ListaPag',
      {
        params: parametros
      });
  }

  exportarConsultaOcorrencias(
    paginaAtual,
    qtdRegistros,
    campoOrdenacao,
    orientacaoOrdenacao,
    idIntegrador: number,
    idCupom?: string,
    tipoFiltro?: number,
    status?: number[],
    idFuncionario?: number,
    idCliente?: number,
    idTipo?: number,
    inicio?: Date,
    fim?: Date,
    idOcorrencia?: string,
    idFornecedor?: number,
    idSetor?: number,
    numeroNotaFiscal?: string,
    idVendedor?: number
  ) {
    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao)
      .set('tipoFiltro', tipoFiltro ? tipoFiltro.toString() : '0')
      .set('status', status.toString())
      .set('idIntegrador', idIntegrador.toString());

    if (idCupom) {
      parametros = parametros.set('idCupom', idCupom.toString());
    }

    if (idFuncionario) {
      parametros = parametros.set('idFuncionario', idFuncionario.toString());
    }

    if (idFornecedor) {
      parametros = parametros.set('idFornecedor', idFornecedor.toString());
    }

    if (idCliente) {
      parametros = parametros.set('idCliente', idCliente.toString());
    }

    if (idTipo) {
      parametros = parametros.set('idTipo', idTipo.toString());
    }

    if (inicio) {
      parametros = parametros.set('inicio', inicio.toISOString());
    }

    if (fim) {
      parametros = parametros.set('fim', fim.toISOString());
    }

    if (idOcorrencia) {
      parametros = parametros.set('idOcorrencia', idOcorrencia);
    }

    if (idSetor) {
      parametros = parametros.set('idSetor', idSetor.toString());
    }

    if (numeroNotaFiscal) {
      parametros = parametros.set('numeroNotaFiscal', numeroNotaFiscal);
    }

    if (idVendedor) {
      parametros = parametros.set('idVendedor', idVendedor.toString());
    }

    return this.http.get(globals.apiUrl + '/api/MinhasOcorrencias/ExportarOcorrencias',
      { responseType: 'blob', params: parametros }
    );
  }

  consultarPorId(id: number) {
    return this.http.get<any>(globals.apiUrl + '/api/MinhasOcorrencias/Buscar',
      { params: new HttpParams().set('id', id.toString()) });
  }
}
